import { TabsContext } from "components/EvtKit/tabs/Tabs"
import React, { ReactNode, memo, useCallback, useContext, useEffect } from "react"
import styled from "styled-components"

const TabsListContainer = styled.div`
  width: 500px;
  display: flex;
  align-items: center;
  gap: 16px;
  height: 40px;
  box-shadow: 0px 2px 6px 0px #0000001a;
  border-radius: 10px;
  border: 1px solid transparent;
  background-image: linear-gradient(white, white),
    linear-gradient(
      90deg,
      ${(props) => props.theme.palette.primary_alt_dark} 0%,
      ${(props) => props.theme.palette.primary_dark} 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;

  &.fill-width {
    width: 100%;
  }
`

interface TabsListProps {
  children: ReactNode
  className?: string
}

const TabsListGradient = (props: TabsListProps) => {
  const { children, className } = props

  const { setTabsIdList } = useContext(TabsContext)

  const setTriggerIdsList = useCallback(() => {
    const childrenArray = React.Children.toArray(children)

    const triggerIds = childrenArray.map((child) => {
      if (!React.isValidElement(child)) {
        return
      }

      return child.props.triggerId
    })

    setTabsIdList(triggerIds)
  }, [children, setTabsIdList])

  useEffect(() => {
    setTriggerIdsList()
  }, [])

  return <TabsListContainer className={className}>{children}</TabsListContainer>
}

export default memo(TabsListGradient)
